export default __webpack_public_path__ + "static/bold-neutrals-light-404cdd68b9f49ce941d6a5ad8971bb82.png";